import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AppNameComponent } from '../../../core/components/app-name/app-name.component';
import { BUILD_DATE } from '../../../../build-date';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterModule, AppNameComponent],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
  version = BUILD_DATE;
}
